var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="policy_empty"> <section class="page-info-block"> <div class="container"> <div class="page-info clearfix"> <ol class="breadcrumb pull-left"> <li><a href="#Index"><i class="fa fa-home"></i></a></li> <li class="active">'+
((__t=( resources['X100637'] ))==null?'':__t)+
'</li> </ol> </div> </div> </section> <section class="content-block page-bg"> <div class="overlay tint"> <div class="container"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100641'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100642'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100643'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100644'] ))==null?'':__t)+
'</p> </div> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px">  <div class="row">  <div class="col-sm-12 col-md-12 vspace-xs"> <h4>'+
((__t=( resources['X100645'] ))==null?'':__t)+
'</h4> <p>'+
((__t=( resources['X100646'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100647'] ))==null?'':__t)+
'</p> <p>'+
((__t=( resources['X100648'] ))==null?'':__t)+
'</p> </div> </div> </div> </section> <section class="content-block default-bg"> <div class="container" style="padding-top:30px;padding-bottom:30px"> <div class="row"> <div class="col-sm-12 col-md-12 vspace-xs"> <h4 class="no-margin-t">'+
((__t=( resources['X100649'] ))==null?'':__t)+
'</h4> <p class="no-margin-t">'+
((__t=( resources['X100650'] ))==null?'':__t)+
'</p> <p class="no-margin-t">'+
((__t=( resources['X100651'] ))==null?'':__t)+
'</p> </div> </div> </div> </section> </div>';
}
return __p;
};
